import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * Ask whether a new milestone on a host mission triggers when ready or when complete.
 */
const AddMilestoneChoiceModal = ({
  isOpen,
  missionName = '',
  onChoose,
  onCancel,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onCancel?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  const displayName = missionName?.trim() || 'this mission';

  return createPortal(
    <>
      <div className="milestone-editor-backdrop" onClick={onCancel} role="presentation" />
      <div
        className="milestone-editor milestone-editor--choice"
        role="dialog"
        aria-label="Add milestone"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="milestone-editor__header">
          <span className="milestone-editor__title">
            <span className="milestone-editor__title-flag" aria-hidden="true">🚩</span>
            Add milestone
          </span>
          <button type="button" className="milestone-editor__close" onClick={onCancel} aria-label="Close">
            ×
          </button>
        </div>

        <p className="milestone-editor__choice-lede">
          Add a milestone on <strong>{displayName}</strong>. When should it trigger?
        </p>

        <div className="milestone-editor__section">
          <div className="milestone-editor__side-toggle milestone-editor__side-toggle--stack">
            <button
              type="button"
              className="milestone-editor__side-btn"
              onClick={() => onChoose?.('input')}
            >
              <span className="milestone-editor__choice-label">When mission is ready</span>
              <span className="milestone-editor__choice-desc">Upstream lines converge here before the mission unlocks</span>
            </button>
            <button
              type="button"
              className="milestone-editor__side-btn"
              onClick={() => onChoose?.('output')}
            >
              <span className="milestone-editor__choice-label">When mission is complete</span>
              <span className="milestone-editor__choice-desc">Lines fan out from here after the mission finishes</span>
            </button>
          </div>
          <p className="milestone-editor__hint">
            Passive marker only — does not block or change dependencies.
          </p>
        </div>
      </div>
    </>,
    document.body,
  );
};

export default AddMilestoneChoiceModal;
